export type { FlowDef } from './fluxosFlowTypes'
export { STATIC_STAGE_CONFIG } from './fluxosStaticStageConfig'
import { coreFlows } from './fluxosFlowsCore'
import { extendedFlows } from './fluxosFlowsExtended'

export const flowsData = [...coreFlows, ...extendedFlows]
